import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0575 14.0509L12.9541 18.5973L15.6301 17.0465L11.8257 11.0502L10.0575 14.0509Z"
      fill="#151718"
    />
    <path
      d="M18.0669 15.222L18.0649 13.9795L13.908 7.50496L12.3658 10.1219L16.3787 16.6119L17.8296 15.7711C17.972 15.6555 18.0581 15.4859 18.0671 15.3029L18.0669 15.222Z"
      fill="#151718"
    />
    <path
      d="M0.647525 16.3939L2.69645 17.5746L9.51483 6.63984L8.35764 6.6093C7.37166 6.59537 6.30954 6.8517 5.82206 7.64745L1.95014 13.6488L0.647525 15.6502V16.3939Z"
      fill="#151718"
    />
    <path
      d="M13.4501 6.63953L10.4002 6.6506L3.50016 18.037L5.91195 19.4256L6.56782 18.3133L13.4501 6.63953Z"
      fill="#151718"
    />
    <path
      d="M19.3521 6.62416C19.3266 5.98633 18.9812 5.40244 18.4403 5.0625L10.8582 0.702226C10.3231 0.432793 9.65466 0.432447 9.1186 0.702053C9.05523 0.734018 1.74522 4.97352 1.74522 4.97352C1.64405 5.02206 1.54659 5.07984 1.45494 5.14546C0.972043 5.49154 0.677696 6.02937 0.647461 6.62022L0.647525 15.6502L1.95014 13.6488L1.9387 6.68126C1.94021 6.65578 1.94341 6.63069 1.94795 6.60595C1.97741 6.44202 2.06893 6.29577 2.20674 6.19694C2.24113 6.17232 9.67602 1.86871 9.69964 1.85691C9.87439 1.76914 10.0965 1.7681 10.2715 1.85418L17.7555 6.159C17.9325 6.27177 18.0435 6.46295 18.0533 6.67196V15.3031C18.0443 15.4861 17.972 15.6555 17.8296 15.7711L16.3787 16.6119L15.6301 17.0465L12.9541 18.5973L10.2405 20.1693C10.0943 20.2221 9.92344 20.2191 9.77849 20.1602L6.56782 18.3133L5.91195 19.4256L8.79726 21.0872C8.89268 21.1415 8.97768 21.1896 9.04745 21.2287C9.15546 21.2893 9.22907 21.3298 9.25507 21.3424C9.46014 21.442 9.75522 21.5 10.0211 21.5C10.2649 21.5 10.5026 21.4552 10.7275 21.3671L18.6096 16.8024C19.062 16.4519 19.3281 15.9233 19.3521 15.3506V6.62416Z"
      fill="#151718"
    />
  </svg>
)
